"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LobbyPlayerBanner = LobbyPlayerBanner;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useStyles_1 = require("~/useStyles");
const player_1 = require("../ui/player");
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    slot: {
        display: "flex",
        alignItems: "center",
        gap: "clamp(0.4rem, 2.5vw, 0.7rem)",
        minWidth: 0,
        padding: "clamp(0.4rem, 2.5vw, 0.6rem)",
        boxSizing: "border-box",
        borderRadius: "0.6rem",
        background: `color-mix(in oklab, ${theme.palette.light.neutral} 6%, ${theme.palette.surface})`,
        border: `1px solid color-mix(in oklab, ${theme.palette.light.neutral} 9%, transparent)`,
        fontFamily: theme.typography.primary,
        color: theme.palette.light.neutral,
        userSelect: "none",
        overflow: "hidden",
    },
    empty: {
        background: "transparent",
        borderStyle: "dashed",
        borderColor: `color-mix(in oklab, ${theme.palette.muted} 40%, transparent)`,
        color: theme.palette.muted,
    },
    avatarFrame: {
        flex: "none",
        display: "grid",
        placeItems: "center",
        overflow: "hidden",
        borderRadius: "50%",
        width: "clamp(2rem, 9vw, 2.75rem)",
        height: "clamp(2rem, 9vw, 2.75rem)",
        background: `color-mix(in oklab, ${theme.palette.light.neutral} 8%, ${theme.palette.surface})`,
    },
    avatarFrameEmpty: {
        background: "transparent",
        border: `1px dashed color-mix(in oklab, ${theme.palette.muted} 45%, transparent)`,
    },
    avatar: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
    },
    emptyImage: {
        width: "62%",
        height: "62%",
        objectFit: "contain",
        opacity: 0.55,
    },
    info: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        minWidth: 0,
        gap: "0.1rem",
        textAlign: "left",
    },
    name: {
        fontWeight: 700,
        fontSize: "clamp(0.85rem, 4vw, 1.05rem)",
        lineHeight: 1.1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    emptyName: {
        fontStyle: "italic",
        fontWeight: 600,
    },
}));
const NO_PLAYER_IMAGE = `${APP_IMAGE_ROOT}/ui/unknown.png`;
function LobbyPlayerBanner({ player }) {
    var _a;
    const styles = useStyles();
    if (!player) {
        return (React.createElement("div", { className: (0, classnames_1.default)(styles.slot, styles.empty) },
            React.createElement("div", { className: (0, classnames_1.default)(styles.avatarFrame, styles.avatarFrameEmpty) },
                React.createElement("img", { src: NO_PLAYER_IMAGE, alt: "", className: styles.emptyImage })),
            React.createElement("div", { className: styles.info },
                React.createElement("span", { className: (0, classnames_1.default)(styles.name, styles.emptyName) }, "Empty"))));
    }
    return (React.createElement("div", { className: styles.slot },
        React.createElement("div", { className: styles.avatarFrame },
            React.createElement(player_1.PlayerAvatar, { player: player, className: styles.avatar })),
        React.createElement("div", { className: styles.info },
            React.createElement("span", { className: styles.name }, player.name),
            React.createElement(player_1.Title, { title: (_a = player.profile) === null || _a === void 0 ? void 0 : _a.title }))));
}
